import useSWR from 'swr'
import { fetcher } from './index'

/**
 * 获取任务状态数据的 Hook
 * 每 30 秒自动刷新一次
 */
export function useTaskStatus() {
  const { data, error, isLoading, isValidating, mutate } = useSWR(
    ['/task-queue/latest'],
    fetcher,
    {
      refreshInterval: 30000, // 30 秒刷新一次
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  )

  const refresh = async () => {
    await mutate(undefined, { revalidate: true })
  }

  return {
    tasks: data || [],
    isLoading,
    isValidating,
    isError: error,
    refresh,
  }
}
